module.exports = __webpack_public_path__ + "img/verify.5891a91d.gif";